import { Menu } from 'react-admin';

import BookIcon from '@mui/icons-material/Book';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import PeopleIcon from '@mui/icons-material/People';
import LabelIcon from '@mui/icons-material/Label';

import UserIcon from '@mui/icons-material/Group';
import KeyIcon from '@mui/icons-material/Key';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddTaskIcon from '@mui/icons-material/AddTask';
import StorageIcon from '@mui/icons-material/Storage';
import TaskIcon from '@mui/icons-material/Task';
import HelpIcon from '@mui/icons-material/Help';
import SubMenu from './SubMenu';
import { getAuthData } from './constant';
// import { MenuItem, Menu } from '@konkretnekosteczki/react-admin-menu-extended';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export const MyMenu = () => {
  const auth = getAuthData();
  const role = auth?.role;

  // 🔒 ROLE 2 → menu sangat terbatas
  if (role === "2" || role === "3") {
    return (
      <Menu>
        <Menu.DashboardItem />
        
      </Menu>
    );
  }

  // 🔒 ROLE 4 → PPID
  if (role === "4") {
    return (
      <Menu>
        <Menu.DashboardItem />
        <Menu.Item to="/presensi_ppid" primaryText="Presensi PPID" leftIcon={<StorageIcon />} />

        <Menu.Item to="/jadwal_piket_ppid" primaryText="Jadwal Piket PPID" leftIcon={<AssessmentIcon />} />
        
        <Menu.Item
        to="/penilaian_piket_ppid"
        primaryText="Penilaian Piket PPID"
        leftIcon={<StorageIcon />}
      />
      </Menu>
    );
  }

  // ✅ ROLE LAIN → menu lengkap
  return (
    <Menu>
      <Menu.DashboardItem />

      <Menu.Item to="/queue" primaryText="Daftar Antrian" leftIcon={<StorageIcon />} />

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Survey
        </AccordionSummary>
        <AccordionDetails>
          <Menu.Item to="/survey" primaryText="Survey Kepuasan" leftIcon={<StorageIcon />} />
          <Menu.Item to="/penilaian_sisera" primaryText="Survey SISERA" leftIcon={<StorageIcon />} />
          <Menu.Item to="/survey_online" primaryText="Survey Online" leftIcon={<StorageIcon />} />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Report
        </AccordionSummary>
        <AccordionDetails>
          <Menu.Item to="/report_queue" primaryText="Report Antrian" leftIcon={<AssessmentIcon />} />
          <Menu.Item to="/penilaian" primaryText="Report Penilaian" leftIcon={<AssessmentIcon />} />
          <Menu.Item to="/jadwal_piket" primaryText="Jadwal Piket" leftIcon={<AssessmentIcon />} />
          <Menu.Item to="/view_rekap_jadwal_final" primaryText="Rekap Jadwal Piket" leftIcon={<AssessmentIcon />} />
        </AccordionDetails>
      </Accordion>

      <Menu.Item
        to="/penilaian_piket"
        primaryText="Penilaian Piket"
        leftIcon={<StorageIcon />}
        style={{ display: auth?.username !== "harningsih" ? "none" : "inherit" }}
      />

      <Menu.Item to="/petugas_pst" primaryText="Petugas PST" leftIcon={<StorageIcon />} />
      <Menu.Item to="/best_employee" primaryText="Best Employee" leftIcon={<StorageIcon />} />
      <Menu.Item to="/scanqr" primaryText="Presensi Agesta" leftIcon={<StorageIcon />} />

      <Menu.Item
        to="/autentifikasi"
        primaryText="Autentifikasi"
        leftIcon={<KeyIcon />}
        style={{ display: role !== "1" ? "none" : "inherit" }}
      />

      <Menu.Item to="/faq" primaryText="FAQ" leftIcon={<HelpIcon />} />
    </Menu>
  );
};
